import { Injectable } from '@angular/core';
import { VerificationCallbackLogsPaged } from 'models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class VerificationCallbackService {
    constructor(private http: HttpClient) { }
  
    get(): Observable<string> {
        return this.http.get<string>(`api/verificationcallback/get/`);
    }

    getLogs(pageIndex: number, pageSize: number): Observable<VerificationCallbackLogsPaged> {
        return this.http.get<VerificationCallbackLogsPaged>(`api/verificationcallback/getlogs/${pageIndex}/${pageSize}`);
    }

    save(callbackUrl: string): Observable<void> {
        return this.http.post<void>('api/verificationcallback/post', callbackUrl);
    }   
}